// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file contact_filter.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file contact_filter.proto.
 */
export const file_contact_filter: GenFile = /*@__PURE__*/
  fileDesc("ChRjb250YWN0X2ZpbHRlci5wcm90bxILZ3JwYy5hcGkudjEiWQoNQ29udGFjdEZpbHRlchIKCgJpZBgBIAEoAxINCgVvcmRlchgCIAEoBRIMCgRuYW1lGAMgASgJEgwKBGRhdGEYBCABKAkSEQoJaXNEZWxldGVkGAUgASgIQgZaBC47cGJiBnByb3RvMw");

/**
 * ContactFilter
 *
 * @generated from message grpc.api.v1.ContactFilter
 */
export type ContactFilter = Message<"grpc.api.v1.ContactFilter"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int32 order = 2;
   */
  order: number;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string data = 4;
   */
  data: string;

  /**
   * @generated from field: bool isDeleted = 5;
   */
  isDeleted: boolean;
};

/**
 * Describes the message grpc.api.v1.ContactFilter.
 * Use `create(ContactFilterSchema)` to create a new message.
 */
export const ContactFilterSchema: GenMessage<ContactFilter> = /*@__PURE__*/
  messageDesc(file_contact_filter, 0);

